import { render, staticRenderFns } from "./UsefulInformation.vue?vue&type=template&id=98ac6d74&"
import script from "./UsefulInformation.vue?vue&type=script&lang=js&"
export * from "./UsefulInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports